import { memo } from "react";

import {
  type Maybe,
  type Image,
} from "@shopify/hydrogen-react/storefront-api-types";

import { useSectionSettings } from "@sections/Root/SectionSettingsContext";
import { type CollectionSectionSettings } from "@tablescape/state";

import { CollectionHeroView } from "./CollectionHero.view";
import { CollectionHeroPlaceholder } from "./CollectionHeroPlaceholder.view";

type Props = {
  breadcrumbsLabel: string;
  collectionHandle: string;
  description?: Maybe<string>;
  heroImage?: Maybe<Image>;
  homeLabel: string;
  isCollectionChanging: boolean;
  isLoading?: boolean;
  title?: Maybe<string>;
};
const CollectionHeroBase = ({
  breadcrumbsLabel,
  collectionHandle,
  description,
  heroImage,
  homeLabel,
  isCollectionChanging,
  isLoading = false,
  title,
}: Props) => {
  const {
    collectionHero: {
      description: descriptionFromSettings,
      heroImage: heroImageFromSettings,
      title: titleFromSettings,
      titleHeadingLevel: titleHeadingLevelFromSettings,
    },
    navigation: { homeUrl },
  } = useSectionSettings<CollectionSectionSettings>();

  return isLoading && isCollectionChanging ? (
    <CollectionHeroPlaceholder
      showHeroImage={!!(heroImage ?? heroImageFromSettings)}
    />
  ) : (
    <CollectionHeroView
      breadcrumbsLabel={breadcrumbsLabel}
      collectionHandle={collectionHandle}
      description={description ?? descriptionFromSettings}
      heroImage={heroImage ?? heroImageFromSettings}
      homeLabel={homeLabel}
      homeUrl={homeUrl}
      isLoading={isLoading}
      title={title ?? titleFromSettings}
      titleHeadingLevel={titleHeadingLevelFromSettings}
    />
  );
};

export const CollectionHero = memo(CollectionHeroBase);
